import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-tips-from-recruiter',
  templateUrl: './tips-from-recruiter.component.html',
  styleUrls: ['./tips-from-recruiter.component.css']
})
export class TipsFromRecruiterComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/main/tips-from-recruiter/tips-from-recruiter.component.ts